import getNotificationLink from './getNotificationLink';

export default getNotificationLink;
